/* hesatek-quote-js-swedish-i18n-v1 */
(function () {
  "use strict";

  if (window.__hesatekQuoteRequestLoaded) return;
  window.__hesatekQuoteRequestLoaded = true;

  var ROOT_SELECTOR = "[data-hqr-root]";
  var HQR_LANG = (document.documentElement.lang || '').toLowerCase();
  var HQR_IS_EN = HQR_LANG.indexOf('en') === 0;
  var HQR_IS_SV = HQR_LANG.indexOf('sv') === 0;
  function hqrText(fi, en, sv) { return HQR_IS_EN ? en : (HQR_IS_SV ? sv : fi); }
  var FOCUSABLE = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "textarea:not([disabled])",
    "select:not([disabled])",
    "[tabindex]:not([tabindex='-1'])"
  ].join(",");

  function parseContext(root) {
    var script = root.querySelector("[data-hqr-context]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || "{}");
    } catch (_error) {
      return null;
    }
  }

  function cleanText(value) {
    return String(value || "").trim().replace(/\s+/g, " ");
  }

  function absoluteImageUrl(value) {
    var imageUrl = String(value || "").trim();
    return imageUrl.indexOf("//") === 0 ? "https:" + imageUrl : imageUrl;
  }

  function getFormValue(form, name) {
    var field = form.elements.namedItem(name);
    return field && "value" in field ? String(field.value).trim() : "";
  }

  function safePageUrl() {
    var url = new URL(window.location.href);
    var variant = url.searchParams.get("variant");
    url.search = variant ? "?variant=" + encodeURIComponent(variant) : "";
    url.hash = "";
    return url.toString();
  }

  function requestId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === "x" ? random : (random & 3) | 8;
      return value.toString(16);
    });
  }

  function pushEvent(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, data || {}));
  }

  function init(root) {
    if (root.dataset.hqrReady === "true") return;

    var context = parseContext(root);
    var dialog = root.querySelector("[data-hqr-dialog]");
    var openButton = root.querySelector("[data-hqr-open]");
    var closeButton = root.querySelector("[data-hqr-close]");
    var form = root.querySelector("[data-hqr-form]");
    if (!context || !dialog || !openButton || !closeButton || !form) return;

    root.dataset.hqrReady = "true";

    var state = {
      step: 1,
      quantity: 1,
      selectedVariant: null,
      startedAt: 0,
      requestId: "",
      submitting: false,
      sent: false,
      lastFocus: null
    };

    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-hqr-step]"));
    var progress = Array.prototype.slice.call(root.querySelectorAll("[data-hqr-progress]"));
    var footer = root.querySelector("[data-hqr-footer]");
    var backButton = root.querySelector("[data-hqr-back]");
    var nextButton = root.querySelector("[data-hqr-next]");
    var nextLabel = root.querySelector("[data-hqr-next-label]");
    var spinner = root.querySelector("[data-hqr-spinner]");
    var success = root.querySelector("[data-hqr-success]");
    var submitError = root.querySelector("[data-hqr-submit-error]");
    var body = root.querySelector("[data-hqr-body]");
    var quantityOutput = root.querySelector("[data-hqr-quantity]");
    var productImage = root.querySelector("[data-hqr-product-image]");
    var variantTitle = root.querySelector("[data-hqr-variant-title]");

    function findVariant(id) {
      var wanted = String(id || "");
      return (context.variants || []).find(function (variant) {
        return String(variant.id) === wanted;
      }) || null;
    }

    function pageSelectedVariant() {
      var urlId = new URL(window.location.href).searchParams.get("variant");
      var section = root.closest(".ht-product") || document;
      var hidden = section.querySelector("[data-ht-vid]");
      var hiddenId = hidden && hidden.value;
      return findVariant(hiddenId || urlId || context.selectedVariantId) || findVariant(context.selectedVariantId) || context.variants[0];
    }

    function renderProduct() {
      var variant = state.selectedVariant || pageSelectedVariant();
      state.selectedVariant = variant;
      if (productImage && variant && variant.imageUrl) {
        productImage.src = absoluteImageUrl(variant.imageUrl);
      }
      if (variantTitle) {
        variantTitle.textContent = variant ? variant.title : "";
        variantTitle.hidden = Boolean(context.hasOnlyDefaultVariant || !variant || variant.title === "Default Title");
      }
      if (quantityOutput) quantityOutput.textContent = String(state.quantity);
    }

    function field(name) {
      return form.elements.namedItem(name);
    }

    function setFieldError(name, message) {
      var input = field(name);
      var error = root.querySelector('[data-hqr-error="' + name + '"]');
      if (input && "setAttribute" in input) {
        if (message) input.setAttribute("aria-invalid", "true");
        else input.removeAttribute("aria-invalid");
      }
      if (error) error.textContent = message || "";
    }

    function validateContact(focusFirst) {
      var values = {
        firstName: cleanText(getFormValue(form, "firstName")),
        lastName: cleanText(getFormValue(form, "lastName")),
        email: getFormValue(form, "email").toLowerCase(),
        phone: cleanText(getFormValue(form, "phone")),
        postalCode: getFormValue(form, "postalCode"),
        message: getFormValue(form, "message")
      };
      var errors = {};

      if (values.firstName.length < 2) errors.firstName = hqrText("Anna etunimi.", "Enter your first name.", "Ange ditt förnamn.");
      if (values.lastName.length < 2) errors.lastName = hqrText("Anna sukunimi.", "Enter your last name.", "Ange ditt efternamn.");
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = hqrText("Anna toimiva sähköpostiosoite.", "Enter a valid email address.", "Ange en giltig e-postadress.");
      if (values.phone && values.phone.replace(/\D/g, "").length < 7) errors.phone = hqrText("Tarkista puhelinnumero.", "Check the phone number.", "Kontrollera telefonnumret.");
      if (!/^\d{5}$/.test(values.postalCode)) errors.postalCode = hqrText("Anna viisinumeroinen postinumero.", "Enter a five-digit postal code.", "Ange ett femsiffrigt postnummer.");
      if (values.message.length > 2000) errors.message = hqrText("Viesti voi olla enintään 2 000 merkkiä.", "The message can contain up to 2,000 characters.", "Meddelandet får innehålla högst 2 000 tecken.");

      ["firstName", "lastName", "email", "phone", "postalCode", "message"].forEach(function (name) {
        setFieldError(name, errors[name] || "");
      });

      var firstError = Object.keys(errors)[0];
      if (firstError && focusFirst) {
        var invalid = field(firstError);
        if (invalid && typeof invalid.focus === "function") invalid.focus();
      }
      return firstError ? null : values;
    }

    function fillReview(values) {
      var variant = state.selectedVariant;
      root.querySelector("[data-hqr-review-product]").textContent = context.productTitle;
      var reviewVariant = root.querySelector("[data-hqr-review-variant]");
      reviewVariant.textContent = variant && variant.title !== "Default Title" ? variant.title : "";
      reviewVariant.hidden = !reviewVariant.textContent;
      root.querySelector("[data-hqr-review-quantity]").textContent = hqrText("Määrä ", "Quantity ", "Antal ") + state.quantity;
      root.querySelector("[data-hqr-review-name]").textContent = values.firstName + " " + values.lastName;
      root.querySelector("[data-hqr-review-postal-code]").textContent = values.postalCode;
      root.querySelector("[data-hqr-review-email]").textContent = values.email;
      root.querySelector("[data-hqr-review-phone]").textContent = values.phone || hqrText("Ei annettu", "Not provided", "Inte angivet");
      root.querySelector("[data-hqr-review-message]").textContent = values.message;
      root.querySelector("[data-hqr-review-message-row]").hidden = !values.message;
    }

    function setStep(step, shouldFocus) {
      state.step = step;
      steps.forEach(function (section) {
        section.hidden = Number(section.dataset.hqrStep) !== step;
      });
      progress.forEach(function (item) {
        var itemStep = Number(item.dataset.hqrProgress);
        item.classList.toggle("is-active", itemStep === step);
        item.classList.toggle("is-complete", itemStep < step);
        if (itemStep === step) item.setAttribute("aria-current", "step");
        else item.removeAttribute("aria-current");
      });

      backButton.hidden = step === 1;
      footer.classList.toggle("is-first", step === 1);
      nextLabel.textContent = step === 1
        ? hqrText("Seuraava", "Next", "Nästa")
        : step === 2
          ? hqrText("Tarjouspyynnön yhteenveto", "Review quote request", "Granska offertförfrågan")
          : hqrText("Lähetä tarjouspyyntö", "Send quote request", "Skicka offertförfrågan");
      submitError.hidden = true;
      if (body) body.scrollTop = 0;

      if (shouldFocus) {
        var heading = root.querySelector('[data-hqr-step="' + step + '"] .hqr-step__heading');
        if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus();
        }
      }
      pushEvent("quote_request_step", {
        quote_step: step,
        product_id: context.productId,
        variant_id: state.selectedVariant && state.selectedVariant.id,
        product_category: context.category
      });
    }

    function openDialog() {
      state.selectedVariant = pageSelectedVariant();
      state.startedAt = Date.now();
      state.requestId = requestId();
      state.sent = false;
      state.submitting = false;
      state.lastFocus = document.activeElement;
      success.hidden = true;
      footer.hidden = false;
      steps.forEach(function (section) { section.hidden = true; });
      renderProduct();
      setStep(1, false);
      dialog.showModal();
      document.body.classList.add("hqr-is-open");
      closeButton.focus();
      pushEvent("quote_request_open", {
        product_id: context.productId,
        variant_id: state.selectedVariant && state.selectedVariant.id,
        product_category: context.category
      });
    }

    function closeDialog() {
      if (state.submitting) return;
      dialog.close();
    }

    function payload(values) {
      var variant = state.selectedVariant;
      // The existing proxy requires the canonical product URL in both payload fields.
      var quotePageUrl = root.dataset.hqrService === "true"
        ? new URL("/products/" + encodeURIComponent(context.productHandle), window.location.origin).href
        : safePageUrl();
      return {
        requestId: state.requestId,
        startedAt: state.startedAt,
        source: "product-page",
        website: getFormValue(form, "website"),
        pageUrl: quotePageUrl,
        contact: values,
        items: [{
          productId: String(context.productId),
          variantId: String(variant.id),
          productTitle: context.productTitle,
          variantTitle: variant.title === "Default Title" ? "" : variant.title,
          sku: variant.sku || "",
          handle: context.productHandle,
          category: context.category,
          quantity: state.quantity,
          unitPriceCents: Number(variant.priceCents || 0),
          currency: "EUR",
          imageUrl: absoluteImageUrl(variant.imageUrl || context.imageUrl),
          pageUrl: quotePageUrl
        }]
      };
    }

    function setSubmitting(active) {
      state.submitting = active;
      nextButton.disabled = active;
      backButton.disabled = active;
      closeButton.disabled = active;
      spinner.hidden = !active;
      nextButton.setAttribute("aria-busy", active ? "true" : "false");
      nextLabel.textContent = active ? hqrText("Lähetetään…", "Sending…", "Skickar…") : hqrText("Lähetä tarjouspyyntö", "Send quote request", "Skicka offertförfrågan");
    }

    async function submit() {
      var values = validateContact(true);
      if (!values || !state.selectedVariant) return;
      setSubmitting(true);
      submitError.hidden = true;

      try {
        var response = await fetch(dialog.dataset.proxyPath || "/apps/hesatek-tarjouspyynto", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload(values))
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || !result.ok) {
          var message = response.status === 404
            ? hqrText("Lähetys ei ole vielä käytössä testiversiossa. Tietoja ei tallennettu.", "Quote submission is not yet available in this test version. No details were saved.", "Det går ännu inte att skicka i testversionen. Inga uppgifter sparades.")
            : response.status === 429
            ? hqrText("Tarjouspyyntöjä on lähetetty liian monta lyhyessä ajassa. Yritä hetken kuluttua uudelleen.", "Too many quote requests were sent in a short time. Please try again shortly.", "För många offertförfrågningar har skickats på kort tid. Försök igen om en stund.")
            : response.status === 409
              ? hqrText("Tarjouspyyntöä käsitellään jo. Odota hetki ja yritä tarvittaessa uudelleen.", "This quote request is already being processed. Wait a moment and try again if needed.", "Offertförfrågan behandlas redan. Vänta en stund och försök igen vid behov.")
              : hqrText("Tarjouspyynnön lähetys ei onnistunut. Tarkista yhteys ja yritä uudelleen.", "The quote request could not be sent. Check your connection and try again.", "Offertförfrågan kunde inte skickas. Kontrollera anslutningen och försök igen.");
          throw new Error(message);
        }

        state.sent = true;
        steps.forEach(function (section) { section.hidden = true; });
        success.hidden = false;
        footer.hidden = true;
        progress.forEach(function (item) {
          item.classList.remove("is-active");
          item.classList.add("is-complete");
          item.removeAttribute("aria-current");
        });
        if (body) body.scrollTop = 0;
        var successTitle = success.querySelector(".hqr-success__title");
        if (successTitle) {
          successTitle.setAttribute("tabindex", "-1");
          successTitle.focus();
        }
        pushEvent("tarjouspyynto_form_fill", {
          form_type: "shopify_native_product_quote",
          product_id: context.productId,
          variant_id: state.selectedVariant.id,
          product_category: context.category,
          quantity: state.quantity
        });
        window.location.assign((HQR_IS_EN ? "/en" : (HQR_IS_SV ? "/sv" : "")) + "/pages/tarjouspyynnon-vahvistus");
      } catch (error) {
        submitError.textContent = error && error.message
          ? error.message
          : hqrText("Tarjouspyynnön lähetys ei onnistunut. Yritä uudelleen.", "The quote request could not be sent. Please try again.", "Offertförfrågan kunde inte skickas. Försök igen.");
        submitError.hidden = false;
        submitError.focus && submitError.focus();
      } finally {
        setSubmitting(false);
      }
    }

    openButton.addEventListener("click", openDialog);
    closeButton.addEventListener("click", closeDialog);
    backButton.addEventListener("click", function () {
      if (state.step > 1) setStep(state.step - 1, true);
    });
    nextButton.addEventListener("click", function () {
      if (state.step === 1) {
        setStep(2, true);
        return;
      }
      if (state.step === 2) {
        var values = validateContact(true);
        if (!values) return;
        fillReview(values);
        setStep(3, true);
        return;
      }
      submit();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (state.step === 3) submit();
    });

    form.addEventListener("input", function (event) {
      var name = event.target && event.target.name;
      if (name) setFieldError(name, "");
    });

    root.querySelector("[data-hqr-quantity-minus]").addEventListener("click", function () {
      state.quantity = Math.max(1, state.quantity - 1);
      renderProduct();
    });
    root.querySelector("[data-hqr-quantity-plus]").addEventListener("click", function () {
      state.quantity = Math.min(10, state.quantity + 1);
      renderProduct();
    });

    dialog.addEventListener("cancel", function (event) {
      if (state.submitting) event.preventDefault();
    });

    dialog.addEventListener("close", function () {
      document.body.classList.remove("hqr-is-open");
      if (state.lastFocus && typeof state.lastFocus.focus === "function") state.lastFocus.focus();
      if (state.sent) {
        form.reset();
        state.quantity = 1;
        state.requestId = "";
      }
    });

    dialog.addEventListener("click", function (event) {
      if (event.target !== dialog || state.submitting) return;
      var rect = dialog.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) closeDialog();
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key !== "Tab") return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (element) {
        return !element.hidden && element.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (root.dataset.hqrService !== "true") document.addEventListener("variant:changed", function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail;
      var matching = findVariant(variant && variant.id);
      if (!matching) return;
      state.selectedVariant = Object.assign({}, matching, {
        title: variant.title || matching.title,
        sku: variant.sku || matching.sku,
        priceCents: Number(variant.price || matching.priceCents || 0),
        imageUrl: matching.imageUrl
      });
      if (dialog.open && state.step === 1) renderProduct();
    });

    state.selectedVariant = pageSelectedVariant();
    renderProduct();
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("hesatek:quote:mount", function (event) { initAll(event.target); });

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
